import React, { useContext, useEffect, useState } from "react";
import useFetch from "../../Hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { userContext } from "../../Contexts/userContext";
import Members from "../../Template/Home/Members/Members";
import { coachesURL } from "../../Hooks/URL";
import Coaches from "../../Template/Home/Coaches/Coaches";
import useFetchWhen from "../../Hooks/useFetchWhen";
import useDelete from "../../Hooks/useDelete";

function CoachesPage() {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();

  const [searchData, setSearchData] = useState("");
  const [search, setSearch] = useState("");
  const [Filter, setFilter] = useState("");

  const [coaches, setCoaches] = useState([]);
  const [coachDeleted, setCoachDeleted] = useState("");
  const [deletedSuccess, setDeletedSuccess] = useState(false);
  const { data, loading, error } = useFetch(coachesURL);
  const {
    data: coachsData,
    loading: coachsLoading,
    error: coachsError,
  } = useFetchWhen(coachesURL, deletedSuccess, setDeletedSuccess);

  const { state: deleteRes } = useDelete(
    `${coachesURL}/${coachDeleted}`,
    coachDeleted,
    null,
    null,
    null,
    "",
    setCoachDeleted
  );

  useEffect(() => {
    if (deleteRes?.data?.status == "success") setDeletedSuccess(true);
  }, [deleteRes]);

  useEffect(() => {
    if (!loading && !error && data) {
      setCoaches(data.data);
    }
  }, [data, loading, error]);

  useEffect(() => {
    if (!coachsLoading && !coachsError && coachsData) {
      setCoaches(coachsData.data);
    }
  }, [coachsData, coachsLoading, coachsError]);

  useEffect(() => {
    setContextData({ ...contextData, page: "coaches", data: "" });
  }, []);

  return (
    <Coaches
      searchData={searchData}
      search={search}
      setSearchData={setSearchData}
      setSearch={setSearch}
      coaches={coaches}
      setCoaches={setCoaches}
      navigate={navigate}
      loading={coachDeleted ? coachsLoading : loading}
      setFilter={setFilter}
      setCoachDeleted={setCoachDeleted}
    />
  );
}

export default CoachesPage;
